<template>
    <div id="prog" class="container">
        <div class="schedule">
            <h2>{{ schedule.title }}</h2>
            <div class="__wrap">
                <div v-for="(item, index) in schedule.list" :key="index" class="__item">
                    <div class="__nowrap">
                        <div class="__time">{{ item.time }}</div>
                        <div class="__title">{{ item.title }}</div>
                    </div>
    
                    <template v-if="'list' in item">
                        <div v-for="(item2, index2) in item.list" :key="index2" class="__item2">
                            <div v-if="item2.title" class="__title __plus">{{ item2.title }}</div>
                            <ul>
                                <li v-for="(item3, index3) in item2.list" :key="index3">{{ item3 }}</li>
                            </ul>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import schedule from '@/lib/schedule';
export default {
    name: 'ScheduleBlock',
    components: {},
    props: {},
    data() {
        return {
            schedule,
        }
    },
    mounted() {
    },
    methods: {}
}
</script>
<style lang="scss">
$primary: #1E9BD8;
$secondary:#FCF9F9;
.schedule{
    text-align: left;
    padding: 10px;
    .__plus + ul{
        padding-left: 30px;
    }
    ul{
        padding-left: 17px;
    }
    .__wrap{
        columns: 1;
        @media ( min-width: 992px ) {
            columns: 2;
        }
    }
    .__item{
        margin-bottom: .5em;
        display: inline-block;
        width: 100%;
        // .__nowrap{
        //     white-space: nowrap;
        // }
        .__time{
            color: $primary;
            font-weight: 600;
            font-size: 1.25em;
            margin-bottom: .25em;
        }
        .__title{
            color: $secondary;
            font-weight: 600;
            font-size: 1.25em;
            text-transform: uppercase;
        }
        .__item2{
            // white-space: normal;
            // text-wrap: wrap;
            padding: .5em 0;
            .__title{
                font-size: 1em;
                text-transform: none;
                font-weight: 400;
                &.__plus{
                    margin-bottom: .0em;
                    margin-left: 22px;
                    &::before{
                      content: '';
                      display: block;
                      position: relative;
                      top: 14px;
                      left: -22px;
                      background-image: url('@/assets/plus.svg');
                      background-size: cover;
                      width: 10px;
                      height: 10px;
                    }
                }
                list-style: none;
            }
        }
    }
}
</style>